/**
 * Cliente das fichas do Mistik Dream.
 *
 * <p>A listagem já traz a ficha inteira: o card mostra HP e SP, que moram dentro do
 * conteúdo. Buscar cada uma para desenhar a barra de vida seria uma chamada por
 * personagem só para pintar a primeira tela.
 */
import { api } from '../../api/cliente';

const BASE = '/api/projetos/mistik-island/mistik-dream/fichas';

export interface Ficha {
  id: number;
  nome: string;
  /** A arte do personagem. Nula: a tela usa o avatar do dono. */
  imagem?: string;
  dono: string;
  nomeDoDono: string;
  /** A cor da conta de quem joga — é ela que pinta o card. */
  corDoDono: string;
  avatarDoDono?: string;
  conteudo: unknown;
  versao: number;
  atualizadoPor?: string;
  atualizadoEm?: string;
}

export const CHAVE_DAS_FICHAS = ['mistik-dream', 'fichas'] as const;

export function listar(): Promise<Ficha[]> {
  return api<Ficha[]>(BASE);
}

/** O dono é sempre quem chama — o corpo não escolhe, e o servidor ignora se tentar. */
export function criar(corpo: { nome: string; imagem?: string; conteudo?: unknown }): Promise<Ficha> {
  return api<Ficha>(BASE, { method: 'POST', body: JSON.stringify(corpo) });
}

/**
 * Grava a ficha. Só o mestre passa — quem não for recebe 403 com o motivo.
 *
 * @param versaoBase a versão que a tela leu; o servidor recusa com 409 se alguém gravou
 *        no meio, que é o caso comum de duas fichas abertas na mesma sessão.
 */
export function salvar(
  id: number,
  mudancas: { nome?: string; imagem?: string; conteudo?: unknown; versaoBase?: number }
): Promise<Ficha> {
  return api<Ficha>(`${BASE}/${id}`, { method: 'PATCH', body: JSON.stringify(mudancas) });
}

export function excluir(id: number): Promise<void> {
  return api<void>(`${BASE}/${id}`, { method: 'DELETE' });
}
